// 固定ページパス
export const ROOT_PATH = '/'                            // ルートパス
export const SIGN_IN_PATH = '/sign-in'                  // ログイン
export const SIGN_UP_PATH = '/sign-up'                  // 会員登録
export const TERM_PATH = '/terms'                       // 利用規約
export const INQUIRY_PATH = '/inquiry'                  // お問い合わせ
export const COMPANY_PATH = '/company'                  // 会社概要
export const PRIVACY_POLICY_PATH = '/privacy-policy'

// ユーザーパス
export const USER_MYPAGE_PATH = '/user/mypage'          // マイページ
export const USER_FIRST_PROF_PATH = '/user/profile/new' // 最初のプロフィール入力
export const USER_EDIT_PATH = '/user/profile/edit'      // プロフィール編集
export const USER_CREDIT_EDIT_PATH = '/user/credit-card'// クレジットカード情報
export const USER_BANK_EDIT_PATH = '/user/bank'         // 銀行口座情報
export const USER_MESSAGES_PATH = '/user/mypage/messages' // メッセージルーム
export const USER_NOTIFICATION_PATH = '/user/notification'
export const USER_SHOW_PATH = '/user-page/:id'

// export const USER_MY_COMMUNITIES_PATH = '/user/mypage/communities'
export const USER_JOINED_COMMUNITIES_PATH = '/user/mypage/communities/joined'
export const GOOGLE_CALLBACK_PATH = '/user/google-sign-in'
export const TWITTER_CALLBACK_PATH = '/user/twitter-sign-in'
export const FACEBOOK_CALLBACK_PATH = '/user/facebook-sign-in'

// コミュニティパス
export const COMMUNITIES_PATH = '/communities'                // コミュニティ一覧
export const COMMUNITIES_CAT_PATH = '/communities/categories/:cat_id'
export const COMMUNITIES_AREA_PATH = '/communities/area/:area_id'

export const COMMUNITY_PATH = '/community/:id'                // コミュニティ詳細
export const COMMUNITY_EDIT_PATH = '/community/:id/edit'      // コミュニティ編集
export const COMMUNITY_MANAGE_PATH = '/community/:id/manage'
export const COMMUNITY_NEW_PATH = '/community-new'            // コミュニティ新規作成
export const COMMUNITY_PREVIEW_PATH = '/community/:id/preview'    // コミュニティプレビュー
export const COMMUNITY_POSTS_PATH = '/community/:id/posts'    // コミュニティ投稿一覧

export const SEARCH_RESULT_PATH = '/community/search/result'


// メッセージルーム
export const MESSAGE_ROOM_PATH = '/message-room/:id'

// 静的ページ
export const TERMS_PATH = '/terms'


// WEBPACK FOOTER //
// ./src/constants/Routing.js